import React, { Component } from "react";
import { connect } from "react-redux";
import { submit } from "redux-form";
import { Scrollbars } from "react-custom-scrollbars";
import SideColumnWrapper from "../../../components/SideColumn";
import Toolbar from "../../../components/SideColumn/Toolbar";
import { checkPermissions } from "../../../utils/UserPermissions";

import { Button } from "reactstrap";

class EditSideColumn extends Component {
  submitAction() {
    this.props.dispatch(submit("EditAdminUserForm"));
  }

  render() {
    return (
      <SideColumnWrapper>
        <Toolbar>
          {checkPermissions(this.props.permissions, [
            "ALL",
            "CREATE_ADMIN_USERS",
            "EDIT_ADMIN_USERS"
          ]) && (
            <Button
              color="success"
              onClick={() => this.props.dispatch(submit("EditAdminUserForm"))}
            >
              Save
            </Button>
          )}

          {this.props.mode === "edit" &&
            checkPermissions(this.props.permissions, [
              "ALL",
              "DELETE_ADMIN_USERS"
            ]) && (
              <Button
                color="danger"
                outline
                onClick={() => this.props.remove()}
              >
                <i className="far fa-trash-alt" />
              </Button>
            )}

          <a href="/admin-users">
            <Button color="primary" outline>
              <i className="far fa-list-alt" />
            </Button>
          </a>
        </Toolbar>
        <Scrollbars />
      </SideColumnWrapper>
    );
  }
}

export default connect()(EditSideColumn);



// WEBPACK FOOTER //
// ./src/system/containers/AdminUsers/components/EditSideColumn.jsx